// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VIP_SelectWrapper__wrapper"};